// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************
*  Transitions Tokens
******************************/
:root {
  --m-transition-slow: all ease-out 1s;
  --m-transition-default: all ease-out 0.6s;
  --m-transition-fast: all ease-out 0.2s;
  --m-transition-second-slow: 0.3s;
  --m-transition-second-default: 0.6s;
  --m-transition-second-fast: 1s;
}

.text {
  color: var(--ma-transition-default);
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens/_transitions.scss"],"names":[],"mappings":"AAAA;;8BAAA;AAGA;EACI,oCAAA;EACH,yCAAA;EACA,sCAAA;EACA,gCAAA;EACA,mCAAA;EACA,8BAAA;AACD;;AAEA;EACI,mCAAA;AACJ","sourcesContent":["/******************************\n*  Transitions Tokens\n******************************/\n:root {\n    --m-transition-slow: all ease-out 1s;\n\t--m-transition-default: all ease-out 0.6s;\n\t--m-transition-fast: all ease-out 0.2s;\n\t--m-transition-second-slow: 0.3s;\n\t--m-transition-second-default: 0.6s;\n\t--m-transition-second-fast: 1s;\n}\n\n.text {\n    color: var(--ma-transition-default);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
